import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import * as linearConferenceActions from 'action/linearConference'
import * as reportActions from 'action/report'

import CommonReport from 'component/commonReport/CommonReport'
import columns from 'component/linearConference/columns'
import { renderToastWarn } from 'utils/ToastUtils'
import applyMask from 'component/report/utils/Formatter'

const LINEAR_CSV = 46
let signalController;

class LinearConferenceReport extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    error: PropTypes.object,
    fetchLinearConferenceFlux: PropTypes.func.isRequired,
    fetchFluxReport: PropTypes.func.isRequired,
    records: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
  }

  state = {
    formData: {},
    lm: '',
    subtypesQuery: false,
  }

  getFormFields() {
    const { translate } = this.props
    const { subtypesQuery, lm } = this.state

    const fields = [
      {
        type: 'branchs',
        name: 'branchIdList',
        label: translate('field.store'),
        help_text: translate('adjustmentValues.branch.select'),
        required: true,
      },
      {
        type: 'sections',
        name: 'sectionIdList',
        label: translate('section'),
        help_text: translate('adjustmentValues.section.select'),
        onChangeValue: (e) => {
          console.log(e)
          const query = { sectionIdList: e }
          this.setState({ subtypesQuery: query })
          console.log(this.state)
        },
        attrs: {
          disabled: lm.length > 0,
        },
      },
      {
        type: 'subtypes',
        name: 'subtypeList',
        label: translate('subType'),
        help_text: translate('select.subtype'),
        query: this.state.subtypesQuery,

        attrs: {
          disabled: !subtypesQuery || this.state.subtypesQuery.length === 0
        },
      },
      {
        type: 'input',
        name: 'cdLm',
        label: translate('lm_label'),
        help_text: translate('mobile.hint.lm'),
        onChangeValue: (e) => {
          this.setState({ lm: e.target.value })
        },
        attrs: {
          disabled: subtypesQuery && subtypesQuery.sectionIdList.length > 0,
          maxLength: 8,
          mask: '99999999',
        },
      },
      {
        type: 'date_range',
        name: 'period',
        label: translate('field.period.hint'),
        required: true,
      },
    ]

    return fields
  }

  getColumns() {
    const { translate } = this.props

    const cols = {}

    for (const col of columns) {
      if (col.render) {
        cols[col.field] = {
          fixed: col.fixed,
          label: translate(col.headerLabel),
          align: col.align,
          customWidth: col.customWidth || false,
          disableOrder: col.field !== 'dtInclusion',
        }
      }
    }

    return cols
  }

  buildRows() {
    const { records, translate } = this.props

    const rows = []
    let i = 0

    for (const rec of records || []) {
      rows[i] = {}
      for (const col of columns) {
        if (col.render) {
          if (rec[col.field]) {
            if (['c10', 'c50'].includes(col.field)) {
              rows[i][col.field] =
                rec[col.field] !== ' - '
                  ? applyMask(
                      col.type,
                      parseFloat(rec[col.field]),
                      translate,
                      col.headerLabel
                    )
                  : rec[col.field]
            } else {
              rows[i][col.field] = applyMask(
                col.type,
                rec[col.field],
                translate,
                col.headerLabel
              )
            }
          } else {
            rows[i][col.field] = ''
          }
        }
      }
      i++
    }

    return rows
  }

  onSubmit = async (data, callback) => {
    const {
      auth: {
        user: { dsToken },
      },
      fetchLinearConferenceFlux,
    } = this.props

    data.dtStart = data.period[0] ? data.period[0] : ''
    data.dtEnd = data.period[1] ? data.period[1] : ''

    this.setState({ formData: data })

    signalController = new AbortController();

  await fetchLinearConferenceFlux(dsToken, data, null, null, signalController)

    if (this.props.error) {
      renderToastWarn(this.props.error)
    } else {
      const content = {
        data: this.buildRows(),
        total: this.props.count,
      }
      callback(content)
    }
  }

  onExport = async (callback) => {
    const {
      auth: {
        user: { dsToken },
      },
      fetchFluxReport,
    } = this.props

    const { formData } = this.state

    const exportData = {
      tpReport: LINEAR_CSV,
      ...formData
  };

  try {
    await fetchFluxReport(dsToken, { tpReport: LINEAR_CSV }, exportData);
    
    const callbackReturn = true;
    callback(callbackReturn);
  } catch (error) {
      console.error('Error exporting data:', error);
      renderToastWarn('Failed to export data');
      callback(false);
  }
  }

  render() {
    const { translate } = this.props

    return (
      <CommonReport
        isFlux
        translate={translate}
        title={translate('menu.linearConference.report')}
        onSubmit={this.onSubmit}
        onExport={this.onExport}
        fields={this.getFormFields()}
        columns={this.getColumns()}
        order
        limit={10}
        defaultOrder='dtInclusion'
      />
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({
  linearConferenceReducer,
  paginateReducer,
  reportReducer,
}) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  error: reportReducer.get.error,
  pages: paginateReducer.pages,
  records: linearConferenceReducer.records,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...linearConferenceActions, ...reportActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    LinearConferenceReport
  )
)

export { LinearConferenceReport }
